<template>
  <div>
    <template v-if="isLoadedNormal">
      <form @submit.prevent="save">

        <table class="prop-table mb-5">
          <tr class="goal">
            <th>Цель</th>
            <td>{{ commonScoreInfo.goal | getFormattedNumber }}</td>
          </tr>
          <tr class="real-value">
            <th>Реальное значение</th>
            <td>
              {{ commonScoreInfo.realValue | getFormattedNumber }}
              ({{ realValuePercentStr }})
            </td>
          </tr>
          <tr class="correction">
            <th><label for="correction">Поправка</label></th>
            <td>
              <input v-model.number="commonScoreInfo.correction" id="correction" class="form-control level-input" type="number" min="0" required v-focus>
            </td>
          </tr>
          <tr class="corrected-value">
            <th>Исправленное значение</th>
            <td>
              {{ correctedValue | getFormattedNumber }}
              ({{ correctedValuePercentStr }})
            </td>
          </tr>
          <tr>
            <td colspan="2" class="pt-2">
              <b-progress :max="goal" height="0.6em">
                <b-progress-bar :value="realValue" variant="success"/>
                <b-progress-bar :value="commonScoreInfo.correction" variant="secondary"/>
              </b-progress>
            </td>
          </tr>
        </table>

        <b-button :to="{name: 'season_info'}">Cancel</b-button>
        <b-button type="submit" variant="primary">Save</b-button>
      </form>
    </template>

    <loading-indicator v-if="isLoading"/>
  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

import LoadingIndicator from './LoadingIndicator.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'SeasonCommonScoreCorrectionEditor',

  components: {
    LoadingIndicator,
  },

  props: {
    seasonId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,
      commonScoreInfo: null,
      isSaving: false,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    /** @returns {number} */
    goal() {
      return this.commonScoreInfo.goal;
    },

    /** @returns {number} */
    realValue() {
      return this.commonScoreInfo.realValue;
    },

    /** @returns {string} */
    realValuePercentStr() {
      const realValuePercent = (this.realValue / this.goal) * 100;
      return realValuePercent.toFixed() + '%';
    },

    /** @returns {number} */
    correctedValue() {
      const info = this.commonScoreInfo;
      return info.realValue + info.correction;
    },

    /** @returns {string} */
    correctedValuePercentStr() {
      const correctedValuePercent = (this.correctedValue / this.goal) * 100;
      return correctedValuePercent.toFixed() + '%';
    },
  },

  created() {
    this.loadCommonScoreInfo();
  },

  methods: {
    loadCommonScoreInfo() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const url = `/season/${this.seasonId}/common_score_info`;

      HTTP.get(url)
      .then(response => {
        this.commonScoreInfo = parseCommonScoreInfo(response.data.data);
        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },

    save() {
      if(this.isSaving) {
        return;
      }
      this.isSaving = true;

      notifier.deleteSenderNotifications(this);

      const data = new FormData();
      data.append('correction', this.commonScoreInfo.correction);

      const url = `/season/${this.seasonId}/common_score_correction`;
      HTTP.post(url, data)
      .then(() => {
        this.isSaving = false;
        notifier.showSuccessAfterTransition('Поправка изменена.');
        this.$router.push({name: 'season_info'});
      })
      .catch(err => {
        this.isSaving = false;
        notifier.showError(err, {sender: this});
      });
    },
  },
};

function parseCommonScoreInfo(data) {
  return {
    goal:       data.goal,
    realValue:  data.realValue,
    correction: parseCorrection(data),
  };
}

function parseCorrection(data) {
  if(data.hasOwnProperty('correction')) {
    return data.correction;
  }
  return 0;
}
</script>

<style scoped>
.goal td,
.real-value td,
.corrected-value td {
  padding-left: 0.9em;
}
</style>